import { render, staticRenderFns } from "./BillingHistoryTable.vue?vue&type=template&id=465c0695"
import script from "./BillingHistoryTable.vue?vue&type=script&lang=js"
export * from "./BillingHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports